import { useRef } from 'react';
import { CAMPAIGN_WIDTH } from '../components/UserViewCampaigns/StyledComponents';

export const useCampaignsToShow = ({
  campaigns,
  showArchivedCampaignSelector,
}) => {
  const wrapperRef = useRef(null);

  const campaignsToShow = Math.round(
    wrapperRef.current?.clientWidth / CAMPAIGN_WIDTH,
  );

  const recentCampaigns = campaigns => campaigns.slice(0, campaignsToShow);
  const olderCampaigns = campaigns => campaigns.slice(campaignsToShow);

  const currentYearCampaigns = campaigns.filter(campaign => {
    const year = new Date(campaign.endDate).getFullYear();
    return year >= new Date().getFullYear();
  });

  const olderCampaignsByYear = campaigns.reduce((acc, campaign) => {
    const year = new Date(campaign.endDate).getFullYear();
    const currentYear = new Date().getFullYear();
    if (year !== currentYear) {
      return {
        ...acc,
        [year]: [...(acc[year] || []), campaign],
      };
    }
    return acc;
  }, {});

  if (showArchivedCampaignSelector) {
    return {
      recentCampaigns: recentCampaigns(currentYearCampaigns),
      olderCampaigns: olderCampaigns(currentYearCampaigns),
      wrapperRef,
      olderCampaignsByYear,
    };
  }
  return {
    recentCampaigns: recentCampaigns(campaigns),
    olderCampaigns: olderCampaigns(campaigns),
    olderCampaignsByYear: [],
    wrapperRef,
  };
};
